import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as userActions from '../../actions/userActions'
import PropTypes from 'prop-types'

import '../../assets/styles/components/activity/ActivityFeedPage.scss'
import Activity from '../activity/Activity'

class ProfileActivities extends React.Component{
  displayActivities(){
    if (this.props.allActivities && this.props.allActivities.length > 0){
      return (
        this.props.allActivities.map(activity =>
          <Activity
            key={activity.id}
            displayComments={false}
            activity={activity}
          />
        )
      )
    } else {
      const { t } = this.props
      const noActivitiesText = (this.props.current_user.id === this.props.user.id)
        ? (t('profile.activitiesWeb.noActivitiesSelf'))
        : (t('profile.activitiesWeb.noActivities', { firstName: this.props.user.first_name }))

      return (
        <div>
          <div className='sky'>
            <div className='empty-putt py-2'>
              <h4 className='text-center'>{noActivitiesText}</h4>
            </div>
          </div>
        </div>
      )
    }
  }

  render(){
    return (
      // eslint-disable-next-line react/no-string-refs
      <div id='profileActivities' ref='profileActivities' style={{ overflow: 'auto' }} onScroll={this.handleScroll}>
        {this.displayActivities()}
      </div>
    )
  }
}

ProfileActivities.propTypes = {
  allActivities: PropTypes.array,
  t: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
  }),
  current_user: PropTypes.shape({
    id: PropTypes.number,
  }),
}

function mapStateToProps(state, _ownProps){
  return {
    ui: state.ui,
    user: state.user.user,
    current_user: state.user.current_user,
  }
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfileActivities))
